export default __webpack_public_path__ + "6dd3e181453de7bd717c5c9867a6e477.svg";